import React from 'react';
import {
  Button,
  CheckPanel,
  Dialog,
  DialogContent,
  DialogFooter,
} from '@taopix/taopix-design-system';
import {useTranslation} from 'react-i18next';
import {useAssistant} from '../../../Context/Assistant/AssistantContext';
import {AssistantActions} from '../../../Context/Assistant/AssistantActionTypes';
import {useUiState} from '../../../Context/UserInterface/UserInterfaceContext';
import {SubStepOptionProps} from './SubStep';
import classNames from 'classnames';

export const PicturesSubStep = ({
  isFirstStep,
  open,
  height,
  width,
  onClose,
  onAfterClose,
  onBack,
  onContinue,
}: SubStepOptionProps) => {
  const assistant = useAssistant();
  const ui = useUiState();
  const {t} = useTranslation(['assistants', 'dialogs']);

  const onChange = (useAllPictures: boolean) => {
    assistant.dispatch(AssistantActions.setUseAllPictures(useAllPictures));
  };

  return (
    <Dialog
      id="assistant-pictures-substep"
      open={open}
      height={height}
      width={width}
      afterClose={() => onAfterClose()}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      title={t('dialogs:str_TitleSmartPictureSelection', {defaultValue: 'Smart Picture Selection'})}
      showTitle={false}
      onClose={onClose}
    >
      <DialogContent>
        <div className={'flex flex-1 sm:flex-col sm:space-y-sm lg:space-x-sm h-full w-full'}>
          <CheckPanel
            title={t('str_LabelIntelligentlySelectPictures', {ns: 'assistants'})}
            content={t('str_MessageIntelligentlySelectPictures', {ns: 'assistants'})}
            titleSize={2}
            onClick={() => onChange(false)}
            pressed={!assistant.state.useAllPictures}
            className={classNames('flex-1', ui.state.isSmallScreen && '[&>div]:pt-lg')}
          />
          <CheckPanel
            title={t('str_LabelUseAllMyPictures', {ns: 'assistants'})}
            content={t('str_MessageUseAllMyPictures', {ns: 'assistants'})}
            titleSize={2}
            onClick={() => onChange(true)}
            pressed={assistant.state.useAllPictures}
            className={classNames('flex-1', ui.state.isSmallScreen && '[&>div]:pt-lg')}
          />
        </div>
      </DialogContent>
      <DialogFooter
        alignment={!ui.state.isSmallScreen && isFirstStep ? 'between' : 'auto'}
        isSmallScreen={ui.state.isSmallScreen}
      >
        <Button
          buttonStyle={ui.state.isSmallScreen ? 'link' : 'negative'}
          label={t('*:str_ButtonClose')}
          onClick={onClose}
        />
        {!isFirstStep && (
          <Button buttonStyle="tertiary" label={t('*:str_LabelBack')} onClick={onBack} />
        )}
        <Button
          buttonStyle="primary"
          label={t('*:str_ButtonContinue')}
          onClick={() => onContinue()}
        />
      </DialogFooter>
    </Dialog>
  );
};
